import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function fieldsMatchValidator(
  field: string,
  confirmField: string,
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const control = formGroup.get(field);
    const matchingControl = formGroup.get(confirmField);

    if (!control || !matchingControl) return null;

    if (matchingControl.errors && !matchingControl.errors["fieldsMismatch"]) {
      // Não sobrescreve outros erros
      return null;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ fieldsMismatch: true });
      return { fieldsMismatch: true };
    } else {
      matchingControl.setErrors(null);
      return null;
    }
  };
}
